module.exports = __webpack_public_path__ + "img/about-us.8f57c851.png";